import { action, observable } from "mobx";
import { store } from "@store";
import { ContactListItemFragment } from "@graphql";

export { ContactListItemFragment };

export type FetchContacts = () => Promise<ContactListItemFragment[]>;

export class ContactSelectorStore {
  @observable private _isLoading = true;
  @observable private _selectedIds: string[] = [];
  @observable private _items: ContactListItemFragment[] = [];

  constructor(private onFetch: FetchContacts) {
    (window as any).contactSelectorStore = this;
  }

  fetch = () => {
    this._isLoading = true;

    this.onFetch()
      .then((data) => (this._items = data))
      .catch((e) => {
        store().snackbars.error(`Cannot fetch contacts\nReason: ${e}`);
      })
      .finally(() => (this._isLoading = false));
  };

  get items() {
    return this._items.sortBy((x) => x.Name);
  }

  get selectedIds() {
    return this._selectedIds;
  }

  get selectedItems() {
    if (this._selectedIds.length === 0) {
      return [];
    }

    return this._items.filter((item) => this._selectedIds.includes(item._id));
  }

  get isLoading() {
    return this._isLoading;
  }

  get allSelected() {
    return this._items.length === this._selectedIds.length;
  }

  @action.bound reset() {
    this._selectedIds = [];
    this._items = [];
  }

  @action.bound toggleItem(id: string) {
    this._selectedIds.toggle(id);
  }

  @action.bound toggleAll() {
    this._selectedIds = this.allSelected ? [] : this._items.map((item) => item._id);
  }
}
